type rgbColor = {
	r: number,
	g: number,
	b: number
}

function padZero(str: string, len: number = 2) {
	const zeros = new Array(len).join('0');
	return (zeros + str).slice(-len);
}

function hexToArray(hex: string): rgbColor {
	hex = hex.trim();

	if (hex.indexOf('#') === 0) {
		hex = hex.slice(1);
	}

	// convert 3-digit hex to 6-digits.
	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}

	if (hex.length !== 6) {
		console.log('Invalid HEX color: ', hex);
	}

	return {
		r: parseInt(hex.slice(0, 2), 16),
		g: parseInt(hex.slice(2, 4), 16),
		b: parseInt(hex.slice(4, 6), 16)
	};
}

function rbgArrayToHex(rgb: rgbColor) {
	// pad each with zeros and return
	return '#' + padZero(rgb.r.toString(16)) + padZero(rgb.g.toString(16)) + padZero(rgb.b.toString(16));
}

export function hexBrightness(hex: string): number {
	const rgb = hexToArray(hex);
	return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
}

export function hexInvertColor(hex: string) {
	let rgb = hexToArray(hex);

	// invert color components
	rgb.r = (255 - rgb.r);
	rgb.g = (255 - rgb.g);
	rgb.b = (255 - rgb.b);

	return rbgArrayToHex(rgb);
}

export function hexRandomColor(): string {
	return '#' + (0x1000000 + Math.random() * 0xffffff).toString(16).slice(1, 6);
}
